import { httpsCallable } from 'firebase/functions';
const cache = new Map();
export function clearOperationalSettingsCache() { cache.clear(); }
export async function loadOperationalSettingsSnapshot(functions, actorUid, workspaceUid, id) {
  if (!actorUid || !workspaceUid || !['main', 'quotation', 'crm'].includes(id)) throw new Error('Invalid settings scope');
  const key = `${actorUid}:${workspaceUid}`;
  let entry = cache.get(key);
  if (!entry || entry.expiresAt < Date.now()) {
    entry = { expiresAt: Date.now() + 300000 };
    entry.promise = httpsCallable(functions, 'getOperationalQuotationSettings')({ workspaceUid }).then(result => result.data.settings)
      .catch(error => { if (cache.get(key) === entry) cache.delete(key); throw error; });
    cache.set(key, entry);
  }
  const settings = (await entry.promise)[id];
  return { exists: () => settings.exists, data: () => settings.data };
}
